import { FormattedMessage } from 'react-intl';

const AuthFooter = ({ dark = false }) => {
  const workfloUrl = 'https://workflo.com';
  const links = [
    { id: 'WORKFLO', label: 'Workflo.com', path: '/' },
    { id: 'BLOG', label: 'Blog', path: '/blog' },
    { id: 'ABOUT_US', label: 'About us', path: '/about' },
    { id: 'CONTACT', label: 'Contact', path: '/contact' },
    { id: 'FEEDBACK', label: 'Feedback', path: '/feedback' },
    { id: 'PRICING', label: 'Pricing', path: '/pricing' },
    { id: 'TERMS', label: 'Terms', path: '/terms-and-conditions' },
    { id: 'FAQS', label: 'FAQS', path: '/faqs' },
  ];

  return (
    <footer className="text-xs px-4 w-full text-center pb-5 pt-2" style={dark ? { color: 'rgba(255,255,255,0.25)' } : { color: '#9ca3af' }}>
      <div className="flex flex-wrap justify-center items-center gap-x-1 gap-y-1">
        {links.map((link, index) => (
          <span key={link.id} className="flex items-center gap-x-1">
            <a
              href={`${workfloUrl}${link.path}`}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:underline"
              style={dark ? { color: 'rgba(255,255,255,0.25)' } : {}}
            >
              <FormattedMessage id={link.id} defaultMessage={link.label} />
            </a>
            {index < links.length - 1 && <span style={{ color: dark ? 'rgba(255,255,255,0.15)' : '#d1d5db' }} className="select-none">·</span>}
          </span>
        ))}
      </div>
    </footer>
  );
};

export default AuthFooter;
